import ViewHelpers from '../../core/utils/view.helpers';

export default class ReadOnlyTableComponent {
	constructor() {
		this.template = require('./jf.read.only.table.view.html');
		this.controller = ReadOnlyTableController;
		this.bindings = {
			entityName: '<',
			columns: '<',
			maxRowsPerPage: '<',
			data: '<',
			showTableTop: '<'
		};
	}
}

ReadOnlyTableComponent.META = {
	name: 'readOnlyTable'
};

class ReadOnlyTableController {

	constructor(JFrogTableViewOptions, $scope) {
		this.JFrogTableViewOptions = JFrogTableViewOptions;
		this.$scope = $scope;
		this.viewHelpers = ViewHelpers;
	}

	$onInit() {
		this.initTable();
	}

	getColumns() {
		return this.columns || [{
			field: 'key',
			header: 'Key',
			width: '50%'
		}, {
			field: 'values',
			header: 'Values',
			width: '50%'
		}];
	}

	getMaxRowsPerPage() {
		return this.maxRowsPerPage || 10;
	}

	getEmptyTableText() {
		return this.entityName ? `No ${this.entityName}s` : 'No Data';
	}

	getEntityName() {
		return this.entityName || 'Item';
	}

	getData() {
		return this.data;
	}

	initTable() {
		this.tableViewOptions = new this.JFrogTableViewOptions(this.$scope);
		this.tableViewOptions
		    .showFilter(this.adminTableTop)
		    .showCounter(this.showTableTop)
		    .showPagination(this.showTableTop)
		    .setColumns(this.getColumns())
		    .setRowsPerPage(this.getMaxRowsPerPage())
		    .setEmptyTableText(this.getEmptyTableText())
		    .setObjectName(this.getEntityName())
		    //.sortBy('artifact_count')
		    .setData(this.getData());
	}
}

ReadOnlyTableController.$inject = [
	'JFrogTableViewOptions',
	'$scope'
];



// WEBPACK FOOTER //
// ./modules/distribution/directives/jf-read-only-table/jf.read.only.table.component.js